import { useState } from 'react';
import { TEAM_DESCRIPTION_MAX, TEAM_NAME_MAX } from '@/lib/teamInfo';

/** A group's or channel's name and description in a bottom sheet, as TextSheet (Gary, 17 Oct). */
export function TeamInfoSheet({ kind, name, description, onSave }: {
  kind: 'group' | 'channel';
  name: string;
  description: string;
  onSave: (name: string, description: string) => Promise<void>;
}) {
  const [newName, setNewName] = useState(name);
  const [newDescription, setNewDescription] = useState(description);
  const [busy, setBusy] = useState(false);
  const noun = kind === 'channel' ? 'Channel' : 'Group';
  const cleanName = newName.replace(/\s+/g, ' ').trim();
  return (
    <div className="chats-pad">
      <h2 className="chats-sheet-title">{`Edit ${noun.toLowerCase()} info`}</h2>
      <p className="chats-sheet-hint">Everyone in the {noun.toLowerCase()} sees the change in the chat.</p>
      <label className="chats-field-label" htmlFor="team-info-name">{`${noun} name`}</label>
      <input id="team-info-name" className="chats-input" maxLength={TEAM_NAME_MAX} value={newName} onChange={(e) => setNewName(e.target.value)} autoFocus />
      <label className="chats-field-label" htmlFor="team-info-description">Description (optional)</label>
      <textarea id="team-info-description" className="chats-input chats-input--stack" rows={4} maxLength={TEAM_DESCRIPTION_MAX} value={newDescription}
        onChange={(e) => setNewDescription(e.target.value)} placeholder={`What this ${noun.toLowerCase()} is for`} />
      <p className="chats-sheet-hint chats-team-info-count">{newDescription.length} of {TEAM_DESCRIPTION_MAX}</p>
      <button type="button" className="chats-btn" disabled={busy || !cleanName}
        onClick={() => { setBusy(true); void onSave(cleanName, newDescription.trim()).finally(() => setBusy(false)); }}>Save</button>
    </div>
  );
}
